export default __webpack_public_path__ + "static/media/knight_loop.de4377ef.gif";